import {
  DislikeFilled,
  LikeFilled,
  MinusOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons'
import {
  Badge,
  Button,
  Col,
  Dropdown,
  Menu,
  message,
  Modal,
  Popover,
  Row,
  Tabs,
  Tag,
} from 'antd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import {
  ArrowLeftBroken,
  DocumentOutlineIcon,
  DownloadMinimalisticOutlineIcon,
  HistoryOutlineIcon,
  MenuDotsBoldIcon,
  Pen2OutlineIcon,
  PenOutlineIcon,
  TrashBin2OutlineIcon,
  UnreadOutlineIcon,
  UserPlusBrokenIcon,
} from '../../../components/AppIcon'
import { EmptyText, WordBreak } from '../../../components/Common/CellText'
import FileItemV3 from '../../../components/Common/FileItemComponent/FileItemV3'
import { KeyValueItem } from '../../../components/Common/KeyValueItem'
import { StatusTag } from '../../../components/Common/StatusTag'
import AppPageHeader from '../../../components/AppPageHeader'
import PopoverWatchTime from '../../../components/PopoverWatchTime'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_FORMAT_SLASH,
  TYPE_STATUS,
  VIEWLOG_DATE,
  WORK_STATUS,
} from '../../../constants'
import DashboardLayout from '../../../layouts/DashboardLayout'
import utils from '../../../utils'
import ListHistoryLogModal from '../../ListHistoryLog/ListHistoryLogModal'
import WorkPdf from '../DrawerWork/WorkPdf'
import PopupAddEditPersonVoteV2 from './PopupAddEditPersonVoteV2'
import PopupAddPersonWorkV2 from './PopupAddPersonWorkV2'
import PopupElectronicReleaseFormV2 from './PopupElectronicReleaseFormV2'
import WorkDetailCommentList from './WorkDetailCommentList'
import WorkDetailSubTaskList from './WorkDetailSubTaskList'
import WorkDetailUpdateModal from './WorkDetailUpdateModal'
import { AppTable } from '../../../components/AppTable/AppTable'
import { VOTE_STATUS_CONFIG } from './constants'
import { Link } from 'react-router-dom'

const WorkDetailPageV2 = props => {
  const {
    selectUserStore,
    history,
    workStore,
    loadingAnimationStore,
    notificationStore,
    match,
    authenticationStore,
    aclStore,
    voteStore,
  } = props || {}
  const { currentUser } = authenticationStore

  const [activeTab, setActiveTab] = useState('1')
  const [isOpenUpdateModal, setIsOpenUpdateModal] = useState(false)
  const [isOpenReleaseModal, setIsOpenReleaseModal] = useState(false)
  const [isOpenAddPersonModal, setIsOpenAddPersonModal] = useState(false)
  const [isOpenAddPersonVoteModal, setIsOpenAddPersonVoteModal] = useState(
    false
  )
  const [isVisibleHistory, setIsVisibleHistory] = useState(false)
  const [documentHistory, setDocumentHistory] = useState({})

  const { workDetail, commentWorkList } = workStore

  let { code_work } = match.params || {}

  const fetchWorkDetails = async code => {
    if (code) {
      loadingAnimationStore.showSpinner(true)
      try {
        await workStore.getWorkDetail(code, false, false)
      } catch (err) {
        history.push('/works')
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    }
  }

  const getCommentWorkList = async code => {
    try {
      loadingAnimationStore.showSpinner(true)
      await workStore.getCommentWorkList(code)
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    if (code_work) void fetchWorkDetails(code_work)
  }, [code_work])

  useEffect(() => {
    if (workDetail?.code) {
      void getCommentWorkList(workDetail?.code)
    }
  }, [workDetail?.code])

  useEffect(() => {
    ;(async () => {
      try {
        loadingAnimationStore.showSpinner(true)
        workDetail?.code && (await voteStore.getVoteDetail(workDetail?.code))
      } catch (error) {
        console.log(error)
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
  }, [workDetail?.code])

  useEffect(() => {
    return () => {
      workStore.clearWorkStore()
      notificationStore.clearNotificationType()
    }
  }, [])

  const isCompletedWork = workDetail?.status === WORK_STATUS.COMPLETE

  const handlerList = workDetail?.assignees
    ? selectUserStore.convertListToDefault(
        toJS(workDetail?.assignees).filter(
          el =>
            el.permission === ASSIGNEE_TYPE.HANDLER &&
            el.assignee_code !== 'admin'
        )
      )
    : []

  const followerList = workDetail?.assignees
    ? selectUserStore.convertListToDefault(
        toJS(workDetail?.assignees).filter(
          el =>
            el.permission === ASSIGNEE_TYPE.FOLLOWER &&
            el.assignee_code !== 'admin'
        )
      )
    : []

  const handleUpdateStatusWork = async status => {
    loadingAnimationStore.showSpinner(true)
    try {
      await workStore.updateStatusWork(workDetail?.code, status)
      await workStore.getWorkDetail(workDetail?.code)

      if (status === WORK_STATUS.COMPLETE) {
        return message.success('Bạn đã đánh dấu công việc hoàn thành!')
      }
      message.success('Bạn đã đánh dấu công việc là đang thực hiện!')
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const hasEditPermission =
    workDetail?.status !== WORK_STATUS.COMPLETE &&
    currentUser?.username ===
      workDetail?.assignees?.find(el => el.permission === ASSIGNEE_TYPE.CREATE)
        .assignee_code &&
    aclStore.checkAccessControlAction(
      workDetail?.parent_id
        ? ACL_ACTION_TYPE.sua_cong_viec_phu__WORK
        : ACL_ACTION_TYPE.edit__WORK
    )

  const exportWork = () => {
    utils.exportPDF('divToPrint', workDetail?.title)
  }

  const handleDeleteWork = async () => {
    loadingAnimationStore.showSpinner(true)
    try {
      await workStore.deleteWork(workDetail?.code)
      if (workDetail?.parent_id) {
        history.replace(`/works/view/${workDetail?.parent_id}`)
      } else {
        history.replace('/works')
      }
      message.success('Xóa công việc thành công!')
    } catch (err) {
      console.log(err)
      if (err?.errorCode === 'WORK-106') {
        message.error('Công việc này đã được gán ở KPI nên không thể xóa')
      } else message.error(err?.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const showConfirmDeleteWork = () => {
    Modal.confirm({
      title: 'Bạn có muốn xóa công việc này không?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteWork()
      },
    })
  }

  const handleSendVote = async (userCode, voteResult) => {
    try {
      loadingAnimationStore.showSpinner(true)
      await voteStore.updateVote(userCode, { result: voteResult })
      await voteStore.getVoteDetail(workDetail?.code)
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const menuDropdownItems = (
    <Menu>
      {Boolean(
        workDetail?.status !== WORK_STATUS.COMPLETE &&
          (currentUser?.username ===
            workDetail?.assignees?.find(
              el => el.permission === ASSIGNEE_TYPE.CREATE
            ).assignee_code ||
            handlerList.some(el => currentUser?.username === el.id))
      ) && (
        <Menu.Item
          key="add_person"
          onClick={() => setIsOpenAddPersonModal(true)}
          icon={<UserPlusBrokenIcon style={{ width: 18, height: 18 }} />}>
          <span>Thêm người</span>
        </Menu.Item>
      )}
      {Boolean(
        workDetail?.status !== WORK_STATUS.COMPLETE &&
          !workDetail?.parent_id &&
          aclStore.checkAccessControlAction(ACL_ACTION_TYPE.phat_hanh__WORK)
      ) && (
        <Menu.Item
          key="release"
          onClick={() => setIsOpenReleaseModal(true)}
          icon={<DocumentOutlineIcon style={{ width: 18, height: 18 }} />}>
          <span>Phát hành điện tử</span>
        </Menu.Item>
      )}

      {workDetail?.status !== WORK_STATUS.COMPLETE && (
        <Menu.Item
          key="create_vote"
          icon={<Pen2OutlineIcon style={{ width: 18, height: 18 }} />}
          onClick={() => {
            setIsOpenAddPersonVoteModal(true)
          }}>
          <span>Lấy ý kiến</span>
        </Menu.Item>
      )}

      <Menu.Item
        key="history"
        icon={<HistoryOutlineIcon style={{ width: 18, height: 18 }} />}
        onClick={() => {
          setDocumentHistory({
            code: workDetail.code,
          })
          setIsVisibleHistory(true)
        }}>
        <span>Lịch sử</span>
      </Menu.Item>

      <Menu.Item
        key="print"
        icon={
          <DownloadMinimalisticOutlineIcon style={{ width: 18, height: 18 }} />
        }
        onClick={() => {
          exportWork()
        }}>
        <span>Xuất file</span>
      </Menu.Item>

      {Boolean(
        workDetail?.status !== WORK_STATUS.COMPLETE &&
          currentUser?.username ===
            workDetail?.assignees?.find(
              el => el.permission === ASSIGNEE_TYPE.CREATE
            ).assignee_code &&
          aclStore.checkAccessControlAction(
            workDetail?.parent_id
              ? ACL_ACTION_TYPE.xoa_cong_viec_phu__WORK
              : ACL_ACTION_TYPE.delete__WORK
          )
      ) && (
        <Menu.Item
          key="delete"
          danger
          icon={<TrashBin2OutlineIcon style={{ width: 18, height: 18 }} />}
          onClick={showConfirmDeleteWork}
          // disabled={disableChange}
        >
          <span>Xóa công việc</span>
        </Menu.Item>
      )}
    </Menu>
  )

  return (
    <DashboardLayout>
      <Helmet>
        <title>Chi tiết công việc</title>
      </Helmet>
      <AppPageHeader
        showBackButton
        title={workDetail?.title || ''}
        status={StatusTag(TYPE_STATUS.WORK, workDetail?.status)}
        addon={
          <>
            <Button
              onClick={() =>
                handleUpdateStatusWork(
                  isCompletedWork ? WORK_STATUS.PENDING : WORK_STATUS.COMPLETE
                )
              }
              className="custom-ant-button icon-btn"
              type={isCompletedWork ? 'default' : 'primary'}
              icon={
                isCompletedWork ? null : (
                  <UnreadOutlineIcon style={{ width: 16, height: 16 }} />
                )
              }
              style={
                isCompletedWork
                  ? {}
                  : {
                      backgroundColor: '#2CA87F',
                      borderColor: '#2CA87F',
                    }
              }>
              {isCompletedWork ? 'Chưa hoàn thành' : 'Hoàn thành'}
            </Button>
            {!!hasEditPermission && (
              <Button
                onClick={() => setIsOpenUpdateModal(true)}
                icon={<PenOutlineIcon style={{ width: 16, height: 16 }} />}
                className="custom-ant-button icon-btn"
                type="default">
                Chỉnh sửa
              </Button>
            )}

            <Dropdown overlay={menuDropdownItems} trigger={['click']}>
              <Button
                style={{ width: 40, height: 40, flexShrink: 0 }}
                icon={
                  <MenuDotsBoldIcon
                    style={{
                      width: 20,
                      height: 20,
                      transform: 'rotate(90deg)',
                    }}
                  />
                }
                className="custom-ant-button icon-btn"
                type="default"
              />
            </Dropdown>
          </>
        }
      />
      <div className="custom-create-page-content-wrapper">
        <h3 style={{ marginBottom: 20, fontSize: 18, fontWeight: 600 }}>
          Thông tin chung
        </h3>
        <Row gutter={[20, 16]}>
          {workDetail?.parent_id && (
            <Col span={24}>
              <KeyValueItem
                label="Công việc chính"
                value={
                  <Link to={`/works/view/${workDetail?.parent_id}`}>
                    {workDetail?.parent_title || workDetail?.parent_id}
                  </Link>
                }
              />
            </Col>
          )}
          <Col span={12}>
            <KeyValueItem
              label="Ngày bắt đầu"
              value={renderDate(workDetail?.start_date)}
            />
          </Col>
          <Col span={12}>
            <KeyValueItem
              label="Ngày kết thúc"
              value={renderDate(workDetail?.due_date)}
            />
          </Col>
          <Col span={12}>
            <KeyValueItem
              label={
                workDetail?.work_type === WORK_STATUS.ELECTRONIC
                  ? 'Lãnh đạo ký duyệt'
                  : 'Người xử lý'
              }
              value={
                <>
                  {handlerList.length > 0 ? (
                    <PopoverWatchTime
                      userList={handlerList}
                      title={
                        workDetail?.work_type === WORK_STATUS.ELECTRONIC
                          ? 'Lãnh đạo ký duyệt'
                          : 'Danh sách người xử lý'
                      }
                      isFullViewer={true}
                      compared_date={VIEWLOG_DATE.work_read_until}
                      typeId={workDetail?.code}
                      created_at={workDetail?.created_at}
                    />
                  ) : (
                    <EmptyText>Không có.</EmptyText>
                  )}
                </>
              }
            />
          </Col>
          <Col span={12}>
            <KeyValueItem
              label="Người theo dõi"
              value={
                <>
                  {followerList.length > 0 ? (
                    <PopoverWatchTime
                      userList={followerList}
                      title={'Danh sách người theo dõi'}
                      isFullViewer={true}
                      compared_date={VIEWLOG_DATE.work_read_until}
                      typeId={workDetail?.code}
                      created_at={workDetail?.created_at}
                    />
                  ) : (
                    <EmptyText>Không có.</EmptyText>
                  )}
                </>
              }
            />
          </Col>
          <Col span={24}>
            <KeyValueItem
              label="Nội dung"
              value={
                workDetail?.content ? (
                  WordBreak(workDetail?.content, true)
                ) : (
                  <EmptyText>Không có.</EmptyText>
                )
              }
            />
          </Col>

          <Col span={24}>
            <KeyValueItem
              label={`File đính kèm (${workDetail?.attachments?.length || 0})`}
              value={
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                  {workDetail?.attachments &&
                  workDetail?.attachments?.length > 0 ? (
                    workDetail?.attachments.map(file => (
                      <FileItemV3
                        key={file.file_id}
                        file_id={file.file_id}
                        file_name={file.file_name}
                      />
                    ))
                  ) : (
                    <EmptyText>Không có tài liệu đính kèm.</EmptyText>
                  )}
                </div>
              }
            />
          </Col>

          {voteStore?.voteDetail.length > 0 && (
            <Col span={24}>
              <KeyValueItem
                label="Danh sách lấy ý kiến"
                value={
                  <AppTable
                    dataSource={voteStore?.voteDetail || []}
                    columns={[
                      {
                        title: 'Người dùng',
                        dataIndex: 'name_uppercase',
                        key: 'name_uppercase',
                        width: 200,
                        render: value => {
                          return (
                            <span
                              style={{
                                fontSize: 12,
                                textTransform: 'capitalize',
                              }}>
                              {value?.toLowerCase()}
                            </span>
                          )
                        },
                      },
                      {
                        title: 'Ý kiến',
                        dataIndex: 'vote_status',
                        key: 'vote_status',
                        width: 200,
                        render: (_, record) => {
                          const { result } = record || {}

                          const tagConfig = VOTE_STATUS_CONFIG.find(item => {
                            if (result === null) {
                              return item.value === null
                            }
                            return item.value === result
                          })

                          return (
                            <Tag
                              style={{
                                border: 'none',
                                borderRadius: '4px',
                              }}
                              color={tagConfig?.color}>
                              {tagConfig?.label}
                            </Tag>
                          )
                        },
                      },
                      {
                        title: '',
                        dataIndex: 'action',
                        key: 'action',
                        width: 80,
                        render: (_, record) => {
                          const { assignee_code } = record || {}

                          const items = [
                            {
                              label: 'Đồng ý',
                              key: 1,
                            },
                            {
                              label: 'Không đồng ý',
                              key: 0,
                            },
                            {
                              label: 'Không ý kiến',
                              key: 2,
                            },
                          ]

                          return currentUser.username === assignee_code ? (
                            <Dropdown
                              menu={{
                                items,
                                onClick: props => {
                                  console.log(props)
                                  const { key } = props || {}
                                  if (record?.code) {
                                    void handleSendVote(
                                      record.code,
                                      Number(key)
                                    )
                                  }
                                },
                              }}
                              trigger={['click']}>
                              <Button
                                type="primary"
                                style={{ borderRadius: '8px' }}
                                onClick={e => e.preventDefault()}>
                                Gửi ý kiến
                              </Button>
                            </Dropdown>
                          ) : null
                        },
                      },
                    ]}
                  />
                }
              />
            </Col>
          )}

          <Col span={24}>
            <Tabs
              destroyInactiveTabPane={false}
              activeKey={activeTab}
              onChange={key => setActiveTab(key)}>
              <Tabs.TabPane tab="Ý kiến" key="1" forceRender>
                <WorkDetailCommentList />
              </Tabs.TabPane>
              {!workDetail?.parent_id && (
                <Tabs.TabPane
                  tab={
                    <p
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                        margin: 0,
                      }}>
                      <span>Công việc phụ</span>
                      <Badge
                        count={workDetail?.subwork?.length}
                        overflowCount={10}
                        showZero
                        style={{ backgroundColor: '#9FA2AA' }}
                      />
                    </p>
                  }
                  key="2"
                  forceRender>
                  <WorkDetailSubTaskList setActiveTab={setActiveTab} />
                </Tabs.TabPane>
              )}

              {/* <Tabs.TabPane tab="Hoạt động" key="3" forceRender>
                Nội dung tab hoạt động
              </Tabs.TabPane> */}
            </Tabs>
          </Col>
        </Row>
      </div>

      <div style={{ display: 'none' }}>
        <WorkPdf
          workDetail={workDetail}
          commentList={commentWorkList?.filter(item => !item.deleted) || []}
          isImportantWork={!!workDetail?.important}
          attachments={workDetail?.attachments || []}
          voteList={voteStore?.voteDetail}
        />
      </div>

      <WorkDetailUpdateModal
        isOpenModal={isOpenUpdateModal}
        setIsOpenModal={setIsOpenUpdateModal}
      />
      <PopupElectronicReleaseFormV2
        isOpenModal={isOpenReleaseModal}
        setIsOpenModal={setIsOpenReleaseModal}
      />
      <ListHistoryLogModal
        type={'WORK'}
        isVisible={isVisibleHistory}
        taskInfo={documentHistory}
        handleCloseHistory={() => {
          setIsVisibleHistory(false)
          setDocumentHistory({})
        }}
      />
      <PopupAddPersonWorkV2
        isOpenModal={isOpenAddPersonModal}
        setIsOpenModal={setIsOpenAddPersonModal}
      />
      <PopupAddEditPersonVoteV2
        isOpenModal={isOpenAddPersonVoteModal}
        setIsOpenModal={setIsOpenAddPersonVoteModal}
      />
    </DashboardLayout>
  )
}

export default inject(
  'workStore',
  'voteStore',
  'fileStore',
  'selectUserStore',
  'selectPeopleStore',
  'loadingAnimationStore',
  'authenticationStore',
  'notificationStore',
  'aclStore'
)(observer(WorkDetailPageV2))

const renderDate = date => {
  if (!date) return <EmptyText>Không rõ</EmptyText>
  return <span>{moment(date).format(DATE_FORMAT_SLASH)}</span>
}
